module.exports = __webpack_public_path__ + "static/banner-3f937e2f99a2452ab19ac9b2897566b8.png";